//React Imports
import React, { useEffect, useState } from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { NumericFormat } from 'react-number-format';
import {
  AiFillCloseCircle,
  AiFillFileWord,
  AiFillFilePdf,
  AiFillFileExcel,
  AiFillFileImage,
} from 'react-icons/ai';
import { FaAngleDown, FaAngleUp, FaFileAlt } from 'react-icons/fa';
import {
  removeFile,
  applyRule,
  getAnswers,
  getRefAnswersForSelectionFromKpi,
  parseListTreeItemIdsFromTextValue,
  parseFilterListTreeRefNumber,
  refNumbersLooseEqual,
  getLiveEvidenceRefValidateValue,
  getValToCheckFromStoredAnswer,
  findAnswerForDynamicBlock,
} from '../../services/functions';
import SelectionFromKpiSelectField from '../SelectionFromKpiSelectField';
import { MdChat } from 'react-icons/md';

import Select, { ActionMeta, OnChangeValue } from 'react-select';
import makeAnimated from 'react-select/animated';

import Collapse from 'react-bootstrap/Collapse';
import DatePicker from 'react-datepicker';
import moment from 'moment';

//Components
import TooltipComponent from '../TooltipComponent';
import TooltipAlertComponent from '../TooltipAlertComponent';
import GetTypeInput from '../FormInput/set';
import FormInput from '../FormInput/index';
import { CommentTextArea, Field, IconNewDiscussion } from './styles';
import ChatButton from '../ChatButton/index';

//Style
import { FaTrashAlt } from 'react-icons/fa';
import Api from '../../services/api';
import EvidenceButton from '../EvidenceButton';

function getFormattedDate(date) {
  var year = date.getFullYear();

  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;

  var day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;

  return month + '/' + day + '/' + year;
}

const parseMultiSelectItems = value => {
  if (value == null || value === '') return [];
  if (Array.isArray(value)) return value;
  if (typeof value === 'object') return [value];
  if (typeof value !== 'string') return [value];

  try {
    const parsedValue = JSON.parse(value);
    if (Array.isArray(parsedValue)) return parsedValue;
    return parsedValue == null || parsedValue === '' ? [] : [parsedValue];
  } catch {
    return null;
  }
};

const hasKpiValue = (value, inputType) => {
  if (value == null || value === '') return false;
  if (inputType !== 'multiselectcustom') return true;

  const items = parseMultiSelectItems(value);
  return items === null || items.length > 0;
};

const formatMultiSelectValue = value => {
  const items = parseMultiSelectItems(value);
  if (items === null) return value ?? '';

  return items
    .map(item =>
      item != null && typeof item === 'object'
        ? item.value ?? item.label ?? ''
        : item,
    )
    .filter(item => item != null && item !== '')
    .join(';');
};

const getMultiSelectFormValue = (value, customOptions) => {
  const items = parseMultiSelectItems(value);

  if (items !== null) {
    return items
      .map(item => {
        if (item != null && typeof item === 'object') {
          const itemValue = item.value ?? item.label;
          return itemValue == null
            ? null
            : {
              ...item,
              value: itemValue,
              label: item.label ?? String(itemValue),
            };
        }

        return item == null
          ? null
          : { value: item, label: String(item) };
      })
      .filter(Boolean);
  }

  return (customOptions ?? '')
    .split(';')
    .filter(Boolean)
    .map(option => ({ value: option, label: option }))
    .filter(option => option.value == value);
};

const ColumnSimpleGrouped = ({
  calculations,
  sskList,
  descriptionFragments,
  subSectionGroupColumnInfo,
  moduleObject,
  setModuleObject,
  setNumber,
  setText,
  funcCollapse,
  collapse,
  collapseText,
  collapseCol,
  setComment,
  uploadFile,
  getFile,
  numberOfColumns,
  userRoles,
  showDescriptionColumn,
  totalColumns,
  showUnitColumn,
  showSecondaryUnitsColumn,
  tableColumnOverload,
  descriptionColumnsWidth,
  numberOfRows,
  row,
  blockedField,
  addNewLine,
  kpiEvidences,
  setKPIEvidences,
  removeLastLine,
  hasAddandRemoveButtons,
  MODULE_ID,
  setChatRequest,
  setShowChat,
  chatRequest,
  defaultChatRequest,
  defaultEvidenceRequest,
  evidenceRequest,
  setShowUploadEvidence,
  setEvidenceRequest,
  kpiDiscussions,
  cultureTypeID = null,
  subSectionKPIsToBlock,
  loading,
  kpi,
  subSectionKPIs,
  changeSelectedCultureType,
  selectedCultureTypes,
  changeSelectedCountry,
  selectedCountries,
  changeSelectedFuelType,
  selectedFuelTypes,
  columnRows,
  reordenateColumns,
  loadRefNumbersAndCalculations,
  rejectedKpisList,
  fixedKpisList,
  subSectionID,
  defaultValues,
  setSubsectionKPIs,
  valueCellMinWidthPx = 200,
  valueCellMinWidthByColumnRowID,
}) => {
  const animatedComponents = makeAnimated();
  const [multipleValues, setMultipleValues] = useState([]);
  const [selectCustomValue, setSelectCustomValue] = useState([]);
  const [selectCustomInput, setSelectCustomInput] = useState('');
  const [disabledCustomSelect, setDisabledCustomSelect] = useState(true);
  const isColumnOverload =
    tableColumnOverload !== undefined && tableColumnOverload !== null
      ? tableColumnOverload
      : totalColumns > 12;
  const unitsStickyLeft =
    descriptionColumnsWidth != null && descriptionColumnsWidth !== ''
      ? `${40 + (parseInt(descriptionColumnsWidth) * 8)}px` // Ajuste o multiplicador 8 conforme necessário
      : '240px';
  const [userObject, setUserObject] = useState(
    JSON.parse(localStorage.getItem('@Thrive:user')),
  );

  const formatValuesInTooltip = (
    value,
    decimalSeparator,
    decimalScale,
    suffix,
    isEditable,
    isCalculation,
    isHighlightField,
    isHighLightBorderColor,
    borderColor,
  ) => {
    const borderStyle = {
      border:
        isHighLightBorderColor && value ? `2px solid ${borderColor}` : 'none',
    };
    return isCalculation || (value != null && typeof value == 'number') ? (
      <NumericFormat
        value={value}
        thousandsGroupStyle="thousand"
        decimalScale={decimalScale}
        suffix={suffix}
        displayType="input"
        type="text"
        style={
          isHighlightField
            ? { border: '2px solid #FBBA00' }
            : isHighLightBorderColor
              ? { border: `2px solid ${borderColor}` }
              : {}
        }
        disabled={isEditable ? false : true}
        className={
          !isEditable && isCalculation ? 'read-only-total' : 'read-only'
        }
        thousandSeparator={true}
        allowNegative={true}
        allowLeadingZeros={false}
        allowEmptyFormatting={true}
        fixedDecimalScale={false}
      />
    ) : (
      <>
        <input
          type="text"
          style={{
            border: !isEditable ? 'transparent' : '',
            backgroundColor: !isEditable ? 'transparent' : '',
          }}
          value={value ?? ''}
          disabled={!isEditable}
        />
      </>
    );
  };

  const IconDiscussionToAnswer = kpiDiscussion => {
    if (kpiDiscussion != null) {
      if (
        kpiDiscussion.messages != null &&
        kpiDiscussion.messages != undefined
      ) {
        if (kpiDiscussion.messages.length > 0) {
          if (
            kpiDiscussion.messages[kpiDiscussion.messages.length - 1]
              .createdBy != userObject.id
          ) {
            if (kpiDiscussion.lastDiscussionStatus == 'Open')
              return (
                <IconNewDiscussion className="icon-newdiscussion"></IconNewDiscussion>
              );
          }
        }
      }
    }
  };

  const formatValuesInTooltipNumber = (
    value,
    decimalSeparator,
    decimalScale,
    suffix,
    isCalculation,
    isHighLightBorderColor,
    borderColor,
  ) => {
    const borderStyle = {
      border:
        isHighLightBorderColor && value ? `2px solid ${borderColor}` : 'none',
    };

    return isCalculation || (value != null && typeof value == 'number') ? (
      <NumericFormat
        value={value}
        thousandsGroupStyle="thousand"
        decimalSeparator={decimalSeparator}
        decimalScale={decimalScale}
        suffix={suffix}
        displayType="text"
        type="text"
        style={
          isHighLightBorderColor ? { border: `2px solid ${borderColor}` } : {}
        }
        thousandSeparator={true}
        allowNegative={true}
        allowLeadingZeros={false}
        allowEmptyFormatting={true}
      />
    ) : (
      <>
        <input
          type="text"
          style={borderStyle}
          value={value ?? ''}
          readOnly
        />
      </>
    );
  };

  /** `""` após limpar número ainda satisfaz `!= null`; usar isto só no corpo do Tooltip. */
  const tooltipShowsStoredValue = v =>
    v != null &&
    !(typeof v === 'number' && Number.isNaN(v)) &&
    (typeof v !== 'string' || v.trim() !== '');

  const getFirstSSKToShowUnitMeasure = kpi => {
    if (!kpi?.subSectionKPIs?.length) {
      return '';
    }

    const allColumns = columnRows.filter(
      x => x.subSectionID == subSectionID && x.isParentColumn == false,
    );

    const columnsSorted = [...allColumns].sort((a, b) =>
      a.columnRowOrder > b.columnRowOrder ? 1 : -1,
    );

    // 1) Ordem das colunas: primeira SubSectionKPI que tenha unitMeasure com description
    for (const col of columnsSorted) {
      const ssk = kpi.subSectionKPIs.find(
        x =>
          x.columnRowID == col.columnRowID &&
          x.unitMeasure != null &&
          x.unitMeasure?.description != null &&
          x.unitMeasure?.description !== '',
      );
      if (ssk?.unitMeasure?.description != null) {
        return ssk.unitMeasure.description;
      }
    }

    // 2) Fallback: qualquer SubSectionKPI da KPI com unitMeasure válido
    const withUnit = kpi.subSectionKPIs.find(
      x =>
        x.unitMeasure != null &&
        x.unitMeasure?.description != null &&
        x.unitMeasure?.description !== '',
    );
    return withUnit?.unitMeasure?.description ?? '';
  };

  const isMultiSelectCustomKpi = kpi?.subSectionKPIs?.some(
    sskpi => sskpi.unitMeasure?.inputType === 'multiselectcustom',
  );

  return (
    <>
      <tr key={`KPI_${kpi.kpiid}`}>
        {isColumnOverload ? (
          <>
            <td className="fixed-col fixed-col-icon">
              <TooltipComponent
                style={{
                  backgroundColor: kpi.guidance ? '#112A61' : '#e2e2e2',
                }}
                guidance={kpi.guidance}
                size={14}
                isColumnOverlap={true}
              />
            </td>
            <td
              className="fixed-col fixed-col-desc"
              style={{ minWidth: '200px', left: '4%' }}
            >
              {kpi.description}
            </td>
          </>
        ) : (
          <>
            <td>
              <TooltipComponent
                style={{
                  backgroundColor: kpi.guidance ? '#112A61' : '#e2e2e2',
                }}
                guidance={kpi.guidance}
                size={14}
                isColumnOverlap={false}
              />
            </td>
            <td>{kpi.description}</td>
          </>
        )}
        <td
          className={
            isColumnOverload
              ? 'text-center fixed-col fixed-col-units'
              : 'text-center'
          }
          style={{
            ...(isColumnOverload ? { left: unitsStickyLeft } : {}),
            ...(isMultiSelectCustomKpi
              ? { minWidth: '180px', whiteSpace: 'nowrap' }
              : {}),
          }}
        >
          {kpi != null && kpi.subSectionKPIs[0] != null
            ? getFirstSSKToShowUnitMeasure(kpi)
            : ''}
        </td>
        {
          // kpi.subSectionKPIs.map((sskpi, i) => {
          columnRows.filter(x => x.isParentColumn == false).map((columnRow, index) => {
              var sskpi = kpi.subSectionKPIs.find(x => x.columnRowID == columnRow.columnRowID);
              var numberOfColumns = columnRow.minimumQuantity;
              return [
                ...Array(numberOfColumns > 1 ? numberOfColumns : 1),
              ].map((col, indCol) => {
                  if (sskpi) {
                  var unitMeasure = GetTypeInput(
                    sskpi.unitMeasureID,
                    sskpi.unitMeasure.type,
                  );
                  var isNumber =
                    sskpi.unitMeasure.inputType == 'number' ||
                      sskpi.unitMeasure.inputType == 'decimal'
                      ? true
                      : false;
                  var parentColumn = columnRows.find(
                    x => x.columnRowOrder == columnRow.parentColumnRowID,
                  );
                  var yearID =
                    parentColumn != null && parentColumn.type == 5
                      ? parentColumn?.yearID
                      : null;
                  var isTargetBAT =
                    sskpi.unitMeasure.inputType == 'targetBAT' ? true : false;
                  var calculation =
                    sskpi.inputCalc == 'Calculation' ? sskpi.calculation : null;
                  var isCalculation = false;
                  var alertMessage = sskpi.alertMessage;
                  var selectedCultureTypeID =
                    cultureTypeID == null && columnRow.type == 4
                      ? selectedCultureTypes[indCol]?.value
                      : cultureTypeID;
                  var colDisabled = false;
                  var index = null;
                  var op = `subSectionKPI_${sskpi.subSectionKPIID}_${sskpi.columnRowID}`;
                  var isGlidepathCalculation = false;
                  var glidePathYear = '';
                  var glidepathTargetRefNumber = '';

                  if (
                    sskpi.calculation &&
                    sskpi.calculation.includes('GLIDEPATH')
                  ) {
                    // Regular expression pattern to match four digits after ';'
                    const pattern = /;(\d{4})/g;
                    const finds = sskpi.calculation.match(pattern);
                    if (finds && finds.length >= 1) {
                      const extractedDigits = finds[0].match(/\d{4}/)[0];
                      isGlidepathCalculation = true;
                      glidePathYear = extractedDigits;
                      let regex = /\[(\d+)\]/g;
                      let matches = sskpi.calculation.match(regex);
                      if (matches) {
                        glidepathTargetRefNumber = matches[0]?.match(/\d+/)[0];
                      }
                    }
                  }

                  glidepathTargetRefNumber += `.${glidePathYear}`;

                  
                  if (numberOfColumns > 1) {
                    index = indCol;
                    op = `subSectionKPI_${sskpi.subSectionKPIID}_${sskpi.columnRowID}_c${indCol}`;
                  }

                  if (calculation != null && sskpi.inputCalc == 'Calculation') {
                    isCalculation = true;
                  }

                  var findValue = null;
                  var file = null;
                  var comment = '';
                  var value = null;
                  var country = null;
                  var disabledField = false;
                  var isFromFSMIntegration = null;
                  var highlightField = false;
                  var highlightBorderColor = false;

                  if (numberOfColumns > 1) {
                    findValue = moduleObject.answers.find(
                      x =>
                        x.subSectionKPIID == sskpi.subSectionKPIID &&
                        x.refNumber == sskpi.refNumber &&
                        x.column == indCol,
                    );
                  } else {
                    if (isGlidepathCalculation) {
                      findValue = moduleObject.answers.find(
                        x => x.refNumber == glidepathTargetRefNumber,
                      );
                    } else {
                      findValue = moduleObject.answers.find(
                        x =>
                          x.subSectionKPIID == sskpi.subSectionKPIID &&
                          x.refNumber == sskpi.refNumber,
                      );
                    }
                  }

                  if (sskpi.borderColor) {
                    highlightBorderColor = true;
                  }

                 

                  if (sskpi.valueFromLastYear != null) {
                    //Generates Answer
                    var existsAnswer = moduleObject.answers.find(
                      x => x.subSectionKPIID == sskpi.subSectionKPIID,
                    );
                    if (existsAnswer == null) {
                      var valueToUse = sskpi.valueFromLastYear;
                      var isString = true;
                      if (typeof valueToUse === 'number') {
                        isString = false; // It can be cast to an integer
                      }
                      value = valueToUse;
                      if (!isString) {
                        setNumber({
                          subSectionKPI: sskpi,
                          ref: sskpi.refNumber,
                          value: value,
                          column: numberOfColumns > 1 ? indCol : null,
                          moduleObject: moduleObject,
                          setModuleObject: setModuleObject,
                          subSectionKPIs: subSectionKPIs,
                          cultureTypeID: selectedCultureTypeID ?? null,
                          yearID: yearID,
                          kpiEvidences: kpiEvidences,
                          setKPIEvidences: setKPIEvidences,
                          setSubsectionKPIs: setSubsectionKPIs,
                        });
                      } else {
                        setText({
                          subSectionKPI: sskpi,
                          ref: sskpi.refNumber,
                          value: value,
                          column: numberOfColumns > 1 ? indCol : null,
                          moduleObject: moduleObject,
                          setModuleObject: setModuleObject,
                          subSectionKPIs: subSectionKPIs,
                          setSubsectionKPIs: setSubsectionKPIs,
                        });
                      }
                    }
                  }

                  if (findValue != undefined && findValue != null) {
                    value = isNumber
                      ? findValue.numberValue
                      : getValToCheckFromStoredAnswer(findValue);
                    if (!value && findValue.textValue && isNumber) {
                      const number = parseFloat(findValue.textValue);
                      value = number ? number : null;
                    }
                    file = findValue.file;
                    comment = findValue.comment;
                    isFromFSMIntegration = findValue.isFromFSMIntegration;
                  }

                  if (sskpi.unitMeasure.type == 'Date' && value != null) {
                    value = new Date(moment(value, 'MM/DD/YYYY'));
                  }

                  if (columnRow.type == 2) {
                    if (
                      (selectedCountries[index] == null ||
                        selectedCountries[index]?.text == '') &&
                      !(columnRow.kpiReference == sskpi.refNumber)
                    ) {
                      disabledField = true;
                      colDisabled = true;
                    }

                    if (
                      columnRow.kpiReference == sskpi.refNumber &&
                      !moduleObject.isEditable
                    ) {
                      value = selectedCountries[index]?.text;
                    }
                  } else if (columnRow.type == 3) {
                    if (
                      (selectedFuelTypes[index] == null ||
                        selectedFuelTypes[index]?.text == '') &&
                      !(columnRow.kpiReference == sskpi.refNumber)
                    ) {
                      disabledField = true;
                      colDisabled = true;
                    }

                    if (
                      columnRow.kpiReference == sskpi.refNumber &&
                      !moduleObject.isEditable
                    ) {
                      value = selectedFuelTypes[index]?.text;
                    }
                  } else if (columnRow.type == 4) {
                    if (
                      (selectedCultureTypes[index] == null ||
                        selectedCultureTypes[index]?.text == '') &&
                      !(columnRow.kpiReference == sskpi.refNumber)
                    ) {
                      disabledField = true;
                      colDisabled = true;
                    }

                    if (
                      columnRow.kpiReference == sskpi.refNumber &&
                      !moduleObject.isEditable
                    ) {
                      value = selectedCultureTypes[index]?.text;
                    }
                  } //If it's a country select field
                  else if (
                    sskpi.unitMeasure?.type == 'selectcountry' &&
                    !moduleObject.isEditable
                  ) {
                    value = moduleObject.countriesOptions.find(
                      x => x.value == value,
                    )?.text;
                  } else if (
                    isCalculation &&
                    !parseFilterListTreeRefNumber(sskpi.calculation)
                  ) {
                    disabledField = true;
                  }


                  // Check if field should be blocked due to conditionalBlock rules
                  let shouldShowBlockedAlert = false;
                  let isBlockedBySubSectionKPIsToBlock = false;
                  if (
                    subSectionKPIsToBlock &&
                    subSectionKPIsToBlock?.some(
                      x => {
                        // Match refNumber
                        if (x.refNumber != sskpi.refNumber) return false;
                        // Match row if specified (for row-based fields), or match when row is null/undefined (for non-row fields)
                        if (x.row != null && x.row != undefined) {
                          return x.row == index;
                        }
                        // If row is null/undefined, it applies to all rows (for non-row-based fields)
                        return true;
                      }
                    )
                  ) {
                    isBlockedBySubSectionKPIsToBlock = true;
                    disabledField = true;
                  }

                  //TODO - Set diasbledField based on reject Partial status
                  if (
                    rejectedKpisList != null &&
                    rejectedKpisList?.length > 0
                  ) {
                    disabledField = true;
                  }

                  if (numberOfColumns > 1) {
                    if (
                      rejectedKpisList?.some(
                        x =>
                          x.subSectionKPIID == sskpi.subSectionKPIID &&
                          x.columnIndex == indCol,
                      )
                    ) {
                      disabledField = false;
                    }
                  } else {
                    if (
                      rejectedKpisList?.some(
                        x => x.subSectionKPIID == sskpi.subSectionKPIID,
                      )
                    ) {
                      disabledField = false;
                    }
                  }

                  var hasDiscussion = kpiDiscussions.find(
                    x => x.subSectionKPIID == sskpi.subSectionKPIID && (numberOfColumns > 1 ? x.column == indCol : true)
                  );
                  var discussionCollor = '';
                  if (hasDiscussion) {
                    if (
                      hasDiscussion?.column != null ||
                      hasDiscussion?.row != null
                    ) {
                      if (
                        (hasDiscussion?.column != null
                          ? hasDiscussion?.column == indCol
                          : true) &&
                        (hasDiscussion?.row != null
                          ? hasDiscussion?.row == index
                          : true)
                      ) {
                        discussionCollor =
                          hasDiscussion.lastDiscussionStatus == 'Open'
                            ? '#FFDA7E'
                            : hasDiscussion.lastDiscussionStatus == 'Closed'
                              ? '#ABF0B0'
                              : '';
                      } else {
                        hasDiscussion = null;
                      }
                    } else {
                      discussionCollor =
                        hasDiscussion.lastDiscussionStatus == 'Open'
                          ? '#FFDA7E'
                          : hasDiscussion.lastDiscussionStatus == 'Closed'
                            ? '#ABF0B0'
                            : '';
                    }
                  }
                  var userObj = JSON.parse(
                    localStorage.getItem('@Thrive:user'),
                  );
                  var isApproving = false;
                  //Validate if user is local approver or global
                  if (
                    ([2,4,8].includes(moduleObject?.version?.status) &&
                      userRoles.includes('RoleApprover'))
                  ) {
                    isApproving = true;
                  }

                  if (numberOfColumns > 1) {
                    if (
                      fixedKpisList?.some(
                        x =>
                          x.subSectionKPIID == sskpi.subSectionKPIID &&
                          x.columnIndex == indCol,
                      ) &&
                      !moduleObject.isEditable &&
                      isApproving
                    ) {
                      highlightField = true;
                      highlightBorderColor = true;
                    }


                    if (rejectedKpisList?.some(x => x.subSectionKPIID == sskpi.subSectionKPIID && x.columnIndex == indCol) && userRoles.includes("RoleApprover")) {
                      highlightField = true;
                      highlightBorderColor = true;
                    }
                  } else {
                    if (
                      fixedKpisList?.some(
                        x => x.subSectionKPIID == sskpi.subSectionKPIID,
                      ) &&
                      !moduleObject.isEditable &&
                      isApproving
                    ) {
                      highlightField = true;
                      highlightBorderColor = true;
                    }

                    if (rejectedKpisList?.some(x => x.subSectionKPIID == sskpi.subSectionKPIID) && userRoles.includes("RoleApprover")) {
                      highlightField = true;
                      highlightBorderColor = true;
                    }
                  }

                  if (defaultValues != null && defaultValues?.length > 0) {
                    var defaultValue = defaultValues.find(
                      val => val.subSectionKPIID == sskpi.subSectionKPIID,
                    );
                    if (defaultValue) {
                      var valueToUse =
                        defaultValue.numberValue != null
                          ? defaultValue.numberValue
                          : defaultValue.textValue;
                      disabledField = true;
                      value = valueToUse;
                    }
                  }
                  // Find all rules that block this field and check if any of them match
                  // Similar to handleDynamicBlocking in functions.jsx
                  var shouldBlock = false;

                  // Collect all refNumbers that have rules blocking this field
                  Object.entries(moduleObject.dynamicBlockKpis || {}).forEach(([key, blocks]) => {
                    // Find all blocks in this refNumber that block the current field
                    var blocksThatTargetThisField = blocks.filter(block =>
                      (block.refNumbersToBlock || []).some(
                        refToBlock => refToBlock == sskpi.refNumber,
                      )
                    );

                    if (blocksThatTargetThisField.length > 0) {
                      var currentRow = findValue != null ? findValue.row : null;
                      var blockColumn = numberOfColumns > 1 ? index : null;
                      var blockTargetAnswer = findAnswerForDynamicBlock(
                        moduleObject,
                        key,
                        currentRow,
                        blockColumn,
                      );

                      var targetValue =
                        blockTargetAnswer != null
                          ? getValToCheckFromStoredAnswer(blockTargetAnswer)
                          : null;

                      // Check each rule to see if any matches
                      blocksThatTargetThisField.forEach(block => {
                        // Check if the rule matches:
                        // - If answerToBlock is "null": blockTargetAnswer must be null
                        // - Otherwise: use applyRule to check if targetValue matches answerToBlock
                        if (block.answerToBlock == "null") {
                          // Block if the target answer is null (doesn't exist)
                          if (blockTargetAnswer == null) {
                            shouldBlock = true;
                          }
                        } else {
                          // Use applyRule to check if the target value matches the rule
                          if (targetValue != null && applyRule(targetValue, block.answerToBlock)) {
                            shouldBlock = true;
                          } else if (isBlockedBySubSectionKPIsToBlock) {
                            disabledField = false
                          }
                        }
                      });
                    }
                  });

                  // If should block, disable field and set flag if there's a value
                  // Similar to setElementDisabled logic: paintBorder && disable
                  if (shouldBlock) {
                    disabledField = true;
                    // Check if there's a value (either from findValue or from processed value)
                    var hasValue = false;
                    if (findValue != null) {
                      var valFromFindValue = isNumber
                        ? findValue.numberValue
                        : getValToCheckFromStoredAnswer(findValue);
                      hasValue = hasKpiValue(
                        valFromFindValue,
                        sskpi.unitMeasure.inputType,
                      );
                    }
                    if (
                      !hasValue &&
                      hasKpiValue(value, sskpi.unitMeasure.inputType)
                    ) {
                      hasValue = true;
                    }

                    // Set flag to show alert-input-hasValue class if field is blocked and has a value
                    if (hasValue) {
                      shouldShowBlockedAlert = true;
                    }
                  }

                  var SSKReferenceAnswersOptionsList = [];
                  if (sskpi.unitMeasure.type === 'Selection from kpi' && sskpi.selectAnswersRefNumber) {
                    const refSubSectionKPIForOptions = subSectionKPIs.find(
                      x => x.refNumber === sskpi.selectAnswersRefNumber,
                    );
                    const isListTreeSelectRef =
                      refSubSectionKPIForOptions?.unitMeasure?.description === 'ListTreeSelect';
                    const effectiveListTreeId =
                      refSubSectionKPIForOptions?.listTreeID ?? sskpi.listTreeID;
                    if (refSubSectionKPIForOptions && !isListTreeSelectRef && !effectiveListTreeId) {
                      const refAnswers = getRefAnswersForSelectionFromKpi(
                        moduleObject,
                        sskpi.selectAnswersRefNumber,
                        refSubSectionKPIForOptions,
                        {
                          numberOfRows,
                          numberOfColumns,
                          row,
                          column: indCol,
                        },
                      );
                      const seen = new Set();
                      refAnswers.forEach(a => {
                        const raw =
                          a.textValue != null && String(a.textValue).trim() !== ''
                            ? String(a.textValue).trim()
                            : a.numberValue != null && a.numberValue !== ''
                              ? String(a.numberValue)
                              : null;
                        if (raw && !seen.has(raw)) {
                          seen.add(raw);
                          SSKReferenceAnswersOptionsList.push({ value: raw, text: raw });
                        }
                      });
                    } else if (
                      refSubSectionKPIForOptions &&
                      isListTreeSelectRef &&
                      !effectiveListTreeId
                    ) {
                      const refAnswers = getRefAnswersForSelectionFromKpi(
                        moduleObject,
                        sskpi.selectAnswersRefNumber,
                        refSubSectionKPIForOptions,
                        {
                          numberOfRows,
                          numberOfColumns,
                          row,
                          column: indCol,
                        },
                      );
                      const seen = new Set();
                      refAnswers.forEach(a => {
                        parseListTreeItemIdsFromTextValue(a.textValue).forEach(id => {
                          const key = String(id);
                          if (!seen.has(key)) {
                            seen.add(key);
                            SSKReferenceAnswersOptionsList.push({ value: key, text: key });
                          }
                        });
                      });
                    }
                  }

                  const filterRefNumber =
                    sskpi.inputCalc === 'Calculation'
                      ? parseFilterListTreeRefNumber(sskpi.calculation)
                      : null;
                  const filterSourceSsk = filterRefNumber
                    ? subSectionKPIs.find(x =>
                        refNumbersLooseEqual(x.refNumber, filterRefNumber),
                      )
                    : null;
                  const parentItemIDsFilter = filterSourceSsk
                    ? (() => {
                        const refAnswers = getRefAnswersForSelectionFromKpi(
                          moduleObject,
                          filterRefNumber,
                          filterSourceSsk,
                          {
                            numberOfRows,
                            numberOfColumns,
                            row,
                            column: numberOfColumns > 1 ? indCol : null,
                          },
                        );
                        const ids = [];
                        const seen = new Set();
                        refAnswers.forEach(a =>
                          parseListTreeItemIdsFromTextValue(a.textValue).forEach(id => {
                            if (!seen.has(id)) {
                              seen.add(id);
                              ids.push(id);
                            }
                          }),
                        );
                        return ids;
                      })()
                    : null;
                  const cellMinW =
                    valueCellMinWidthByColumnRowID?.[columnRow.columnRowID] ??
                    valueCellMinWidthPx;
                  const _cellW = Math.max(
                    isColumnOverload ? 100 : 0,
                    cellMinW,
                  );

                  return (
                    <>
                      <td
                        style={{
                          width: `${_cellW}px`,
                          minWidth: `${_cellW}px`,
                          maxWidth: `${_cellW}px`,
                        }}
                        key={`subSectionKPI_td_${indCol}`}
                        colSpan={1}
                      >
                        <div className="row" style={{ position: 'relative' }}>
                          <div className={'col-9'} style={{ padding: 0 }}>                            {isTargetBAT ? (
                              <>
                                <OverlayTrigger
                                  delay={{ hide: 0, show: 100 }}
                                  overlay={props =>
                                    sskpi.targetBAT != null ||
                                      sskpi.inputMessage != null ? ( //validate overlay when field is text on Prompt Actions Modules
                                      <Tooltip {...props}>
                                        {sskpi.targetBAT != null
                                          ? sskpi.targetBAT
                                          : sskpi.inputMessage != null &&
                                            sskpi.inputMessage != ''
                                            ? sskpi.inputMessage
                                            : ''}
                                      </Tooltip>
                                    ) : (
                                      <></>
                                    )
                                  }
                                  placement={'left'}
                                >
                                  <input
                                    name={op}
                                    id={op}
                                    autoComplete="off"
                                    style={
                                      isFromFSMIntegration == true
                                        ? { border: '2px solid #50af47' }
                                        : highlightField
                                          ? { border: '2px solid #FBBA00' }
                                          : {}
                                    }
                                    value={
                                      sskpi.targetBAT != null
                                        ? sskpi.targetBAT
                                        : ''
                                    }
                                    title={''}
                                    inputType={'text'}
                                    className={'read-only'}
                                    disabled={true}
                                  />
                                </OverlayTrigger>
                              </>
                            ) : moduleObject.isEditable ? (
                              isNumber && !isCalculation ? (
                                <>
                                  {loadRefNumbersAndCalculations(sskpi)}
                                  {sskpi.toleranceType ? (
                                    <TooltipAlertComponent
                                      id={`${op}_alert`}
                                      message={sskpi.alertMessage}
                                      className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`}
                                      placement={'left'}
                                    />
                                  ) : null}
                                  <OverlayTrigger
                                    delay={{ hide: 0, show: 100 }}
                                    overlay={props =>
                                      value != null ||
                                        sskpi.inputMessage != null ? ( //validate overlay when field is text on Prompt Actions Modules
                                        <Tooltip {...props}>
                                          {tooltipShowsStoredValue(value)
                                            ? formatValuesInTooltipNumber(
                                              value,
                                              unitMeasure.decimalSeparator,
                                              unitMeasure.decimalPrecision,
                                              unitMeasure.suffix,
                                              isCalculation,
                                            )
                                            : sskpi.inputMessage
                                              ? sskpi.inputMessage
                                              : ''}
                                        </Tooltip>
                                      ) : (
                                        <></>
                                      )
                                    }
                                    placement={'left'}
                                  >
                                    <Field>
                                      <NumericFormat
                                        name={op}
                                        id={op}
                                        autoComplete="off"
                                        className={
                                          moduleObject.isEditable
                                            ? `${findValue?.toleranceInvalid ? 'alert-input ' : ''}${shouldShowBlockedAlert
                                              ? 'alert-input-hasValue'
                                              : ''}`
                                            : 'read-only'
                                        }
                                        disabled={
                                          moduleObject.isEditable
                                            ? blockedField
                                              ? true
                                              : disabledField
                                            : true
                                        }
                                        title={''}
                                        thousandsGroupStyle="thousand"
                                        value={value != null ? value : ''}
                                        decimalSeparator={
                                          unitMeasure.decimalSeparator != ''
                                            ? unitMeasure.decimalSeparator
                                            : '.'
                                        }
                                        decimalScale={
                                          unitMeasure.decimalPrecision
                                        }
                                        suffix={unitMeasure.suffix}
                                        style={
                                          isFromFSMIntegration == true
                                            ? { border: '2px solid #50af47', minWidth: "65px" }
                                            : highlightField
                                              ? { border: '2px solid #50af47', minWidth: "65px" }
                                              : highlightBorderColor
                                                ? {
                                                  border: `2px solid ${sskpi.borderColor}`,
                                                  minWidth: "65px"
                                                }
                                                : { minWidth: "65px" }
                                        }
                                        displayType="input"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={true}
                                        allowLeadingZeros={false}
                                        allowEmptyFormatting={false}
                                        placeholder="00.00"
                                        onValueChange={(values, sourceInfo) => {
                                          setNumber({
                                            subSectionKPI: sskpi,
                                            ref: sskpi.refNumber,
                                            value:
                                              values.formattedValue != ''
                                                ? parseFloat(values.floatValue)
                                                : '',
                                            column:
                                              numberOfColumns > 1
                                                ? indCol
                                                : null,
                                            moduleObject: moduleObject,
                                            setModuleObject: setModuleObject,
                                            subSectionKPIs: subSectionKPIs,
                                            cultureTypeID:
                                              selectedCultureTypeID ?? null,
                                            yearID: yearID,
                                            kpiEvidences: kpiEvidences,
                                            setKPIEvidences: setKPIEvidences,
                                            setSubsectionKPIs: setSubsectionKPIs
                                          });
                                        }}
                                      />
                                      {sskpi.mandatory == true && (
                                        <div class="required-icon">
                                          <div class="text">*</div>
                                        </div>
                                      )}
                                    </Field>
                                  </OverlayTrigger>
                                </>
                              ) : isNumber && isCalculation ? (
                                <>
                                  {loadRefNumbersAndCalculations(sskpi)}
                                  {sskpi.toleranceType ? (
                                    <TooltipAlertComponent
                                      id={`${op}_alert`}
                                      message={sskpi.alertMessage}
                                      className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`}
                                      placement={'left'}
                                    />
                                  ) : null}
                                  <OverlayTrigger
                                    delay={{ hide: 0, show: 100 }}
                                    overlay={props =>
                                      value != null ||
                                        sskpi.inputMessage != null ? ( //validate overlay when field is text on Prompt Actions Modules
                                        <Tooltip {...props}>
                                          {tooltipShowsStoredValue(value)
                                            ? formatValuesInTooltipNumber(
                                              value,
                                              unitMeasure.decimalSeparator,
                                              unitMeasure.decimalPrecision,
                                              unitMeasure.suffix,
                                              isCalculation,
                                            )
                                            : sskpi.inputMessage
                                              ? sskpi.inputMessage
                                              : ''}
                                        </Tooltip>
                                      ) : (
                                        <></>
                                      )
                                    }
                                    placement={'left'}
                                  >
                                    <Field>
                                      <NumericFormat
                                        name={op}
                                        id={op}
                                        autoComplete="off"
                                        className={`${findValue?.toleranceInvalid ? 'alert-input ' : ''}read-only-total`}
                                        disabled
                                        title={''}
                                        thousandsGroupStyle="thousand"
                                        value={value != null ? value : ''}
                                        style={
                                          isFromFSMIntegration == true
                                            ? { border: '2px solid #50af47', minWidth: "65px" }
                                            : highlightField
                                              ? { border: '2px solid #FBBA00', minWidth: "65px" }
                                              : highlightBorderColor
                                                ? {
                                                  border: `2px solid ${sskpi.borderColor}`,
                                                  minWidth: "65px"
                                                }
                                                : { minWidth: "65px" }
                                        }
                                        decimalSeparator={
                                          unitMeasure.decimalSeparator != ''
                                            ? unitMeasure.decimalSeparator
                                            : '.'
                                        }
                                        decimalScale={
                                          unitMeasure.decimalPrecision
                                        }
                                        suffix={
                                          value != null
                                            ? unitMeasure.suffix
                                            : ''
                                        }
                                        displayType="input"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={true}
                                        allowLeadingZeros={false}
                                        allowEmptyFormatting={true}
                                      />
                                      {sskpi.mandatory == true && (
                                        <div class="required-icon">
                                          <div class="text">*</div>
                                        </div>
                                      )}
                                    </Field>
                                  </OverlayTrigger>
                                                </>
                                              ) : sskpi.listTreeID && sskpi.optionsModeView > 0 ? (
                                                <>
                                                  {loadRefNumbersAndCalculations(sskpi)}
                                                  <Field>
                                                    <FormInput
                                                      name={op}
                                                      id={op}
                                                      inputType="listtreeselect"
                                                      listTreeID={sskpi.listTreeID}
                                                      optionsModeView={sskpi.optionsModeView}
                                                      allowSelectOnlyChildrenNodes={sskpi.allowSelectOnlyChildrenNodes}
                                                      maxTreeDepth={sskpi.maxTreeDepth}
                                                      parentItemIDsFilter={parentItemIDsFilter}
                                                      value={value != null ? value : ''}
                                                      disabled={disabledField}
                                                      onChange={(v) => {
                                                        const isMultiple = sskpi.optionsModeView === 2;
                                                        const parsedID = !isMultiple && v ? (Number(v) || null) : null;
                                                        setText({
                                                          subSectionKPI: sskpi,
                                                          ref: sskpi.refNumber,
                                                          value: v,
                                                          column: numberOfColumns > 1 ? indCol : null,
                                                          moduleObject,
                                                          setModuleObject,
                                                          subSectionKPIs,
                                                          cultureTypeID: selectedCultureTypeID ?? null,
                                                          setSubsectionKPIs,
                                                          listTreeItemID: parsedID,
                                                        });
                                                      }}
                                                    />
                                                    {sskpi.mandatory == true && (
                                                      <div class="required-icon">
                                                        <div class="text">*</div>
                                                      </div>
                                                    )}
                                                  </Field>
                                                </>
                                              ) : sskpi.unitMeasure.type === 'Selection from kpi' &&
                                                sskpi.selectAnswersRefNumber ? (
                                                <SelectionFromKpiSelectField
                                                  sskpi={sskpi}
                                                  refSubSectionKPI={subSectionKPIs.find(
                                                    x => x.refNumber === sskpi.selectAnswersRefNumber,
                                                  )}
                                                  fallbackOptions={SSKReferenceAnswersOptionsList}
                                                  numberOfRows={numberOfRows}
                                                  row={row}
                                                  numberOfColumns={numberOfColumns}
                                                  column={indCol}
                                                  moduleObject={moduleObject}
                                                  setModuleObject={setModuleObject}
                                                  op={op}
                                                  value={value}
                                                  disabledField={disabledField}
                                                  loading={loading}
                                                  setText={setText}
                                                  subSectionKPIs={subSectionKPIs}
                                                  findValue={findValue}
                                                  loadRefNumbersAndCalculations={loadRefNumbersAndCalculations}
                                                  cultureTypeID={selectedCultureTypeID ?? null}
                                                  setSubsectionKPIs={setSubsectionKPIs}
                                                  readOnly={false}
                                                />
                                              ) : sskpi.unitMeasure.type === 'selectculture' ? (
                                <>
                                  {loadRefNumbersAndCalculations(sskpi)}
                                  <TooltipAlertComponent
                                    id={`${op}_alert`}
                                    message={sskpi.alertMessage}
                                    className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`}
                                    placement={'left'}
                                  />
                                  <OverlayTrigger
                                    delay={{ hide: 0, show: 100 }}
                                    overlay={props =>
                                      value != null ||
                                        sskpi.inputMessage != null ? ( //validate overlay when field is text on Prompt Actions Modules
                                        <Tooltip {...props}>
                                          {tooltipShowsStoredValue(value)
                                            ? selectedCultureTypes[index]?.text
                                            : sskpi.inputMessage
                                              ? sskpi.inputMessage
                                              : ''}
                                        </Tooltip>
                                      ) : (
                                        <></>
                                      )
                                    }
                                    placement={'left'}
                                  >
                                    <Field>
                                      {moduleObject.cultureTypesOptions.length >
                                        0 && (
                                          <>
                                            <FormInput
                                              disabled={disabledField}
                                              blockedValueAlert={shouldShowBlockedAlert}
                                              style={
                                                highlightField
                                                  ? {
                                                    border: '2px solid #FBBA00',
                                                  }
                                                  : highlightBorderColor
                                                    ? {
                                                      border: `2px solid ${sskpi.borderColor}`,
                                                    }
                                                    : {}
                                              }
                                              options={
                                                moduleObject.cultureTypesOptions
                                              }
                                              name={op}
                                              id={op}
                                              inputType={sskpi.unitMeasure.type}
                                              autoComplete="off"
                                              value={value != null ? value : ''}
                                              onChange={f => {
                                                changeSelectedCultureType(
                                                  f.target.value,
                                                  sskpi,
                                                  indCol,
                                                  columnRow,
                                                );
                                              }}
                                            />
                                          </>
                                        )}
                                      {sskpi.mandatory == true &&
                                        indCol == 0 && (
                                          <div class="required-icon">
                                            <div class="text">*</div>
                                          </div>
                                        )}
                                    </Field>
                                  </OverlayTrigger>
                                </>
                              ) : sskpi.unitMeasure.inputType == 'date' ? (
                                <>
                                  {loadRefNumbersAndCalculations(sskpi)}
                                  <DatePicker
                                    name={op}
                                    id={op}
                                    autoComplete="off"
                                    selected={value != null ? value : ''}
                                    dateFormat="MM/dd/yyyy"
                                    className={`${findValue?.toleranceInvalid ? 'alert-input ' : ''}react-datepicker-popper ${moduleObject.isEditable
                                      ? shouldShowBlockedAlert
                                        ? 'react-datepicker-popper alert-input-hasValue'
                                        : 'react-datepicker-popper'
                                      : 'read-only'
                                      }`}
                                    disabled={
                                      moduleObject.isEditable
                                        ? blockedField
                                          ? true
                                          : disabledField
                                        : true
                                    }
                                    onChange={date => {
                                      var formattedDate =
                                        date != null
                                          ? moment(date).format('MM/DD/YYYY')
                                          : '';

                                      setText({
                                        subSectionKPI: sskpi,
                                        ref: sskpi.refNumber,
                                        value: formattedDate,
                                        column:
                                          numberOfColumns > 1 ? indCol : null,
                                        moduleObject: moduleObject,
                                        setModuleObject: setModuleObject,
                                        subSectionKPIs: subSectionKPIs,
                                        setSubsectionKPIs: setSubsectionKPIs,
                                      });
                                    }}
                                  />
                                </>
                              ) : sskpi.unitMeasure.type === 'selectcountry' ? (
                                <>
                                  {loadRefNumbersAndCalculations(sskpi)}
                                  <TooltipAlertComponent
                                    id={`${op}_alert`}
                                    message={sskpi.alertMessage}
                                    className={`alert-column ${findValue?.toleranceInvalid ? '' : 'hide'}`}
                                    placement={'left'}
                                  />
                                  <OverlayTrigger
                                    delay={{ hide: 0, show: 100 }}
                                    overlay={props =>
                                      value != null ||
                                        sskpi.inputMessage != null ? ( //validate overlay when field is text on Prompt Actions Modules
                                        <Tooltip {...props}>
                                          {tooltipShowsStoredValue(value)
                                            ? value
                                            : sskpi.inputMessage
                                              ? sskpi.inputMessage
                                              : ''}
                                        </Tooltip>
                                      ) : (
                                        <></>
                                      )
                                    }
                                    placement={'left'}
                                  >
                                    <Field>
                                      {moduleObject.countriesOptions.length >
                                        0 && (
                                          <>
                                            <FormInput
                                              className={
                                                `${findValue?.toleranceInvalid ? 'alert-input ' : ''}${shouldShowBlockedAlert
                                                  ? 'alert-input-hasValue'
                                                  : ''}`
                                              }
                                              blockedValueAlert={shouldShowBlockedAlert}
                                              style={
                                                highlightField
                                                  ? {
                                                    border: '2px solid #FBBA00',
                                                  }
                                                  : highlightBorderColor
                                                    ? {
                                                      border: `2px solid ${sskpi.borderColor}`,
                                                    }
                                                    : {}
                                              }
                                              options={
                                                moduleObject.countriesOptions
                                              }
                                              disabled={
                                                moduleObject.isEditable
                                                  ? blockedField
                                                    ? true
                                                    : disabledField
                                                  : true
                                              }
                                              name={op}
                                              id={op}
                                              inputType={sskpi.unitMeasure.type}
                                              autoComplete="off"
                                              value={value != null ? value : ''}
                                              onChange={f => {
                                                setText({
                                                  subSectionKPI: sskpi,
                                                  ref: sskpi.refNumber,
                                                  value: f.target.value,
                                                  column:
                                                    numberOfColumns > 1
                                                      ? indCol
                                                      : null,
                                                  moduleObject: moduleObject,
                                                  setModuleObject:
                                                    setModuleObject,
                                                  subSectionKPIs: subSectionKPIs,
                                                  setSubsectionKPIs: setSubsectionKPIs,
                                                });
                                              }}
                                            />
                                          </>
                                        )}
                                      {sskpi.mandatory == true && (
                                        <div class="required-icon">
                                          <div class="text">*</div>
                                        </div>
                                      )}
                                    </Field>
                                  </OverlayTrigger>
                                </>
                              ) : sskpi.unitMeasure.inputType ==
                                'multiselectcustom' ? (
                                <>
                                  {loadRefNumbersAndCalculations(sskpi)}
                                  <OverlayTrigger
                                    delay={{ hide: 0, show: 100 }}
                                    overlay={props =>
                                      value != null ||
                                        sskpi.inputMessage != null ? ( //validate overlay when field is text on Prompt Actions Modules
                                        <Tooltip {...props}>
                                          {tooltipShowsStoredValue(value)
                                            ? sskpi.unitMeasure.inputType ==
                                              'multiselectcustom'
                                              ? formatMultiSelectValue(value)
                                              : value
                                            : sskpi.inputMessage
                                              ? sskpi.inputMessage
                                              : ''}
                                        </Tooltip>
                                      ) : (
                                        <></>
                                      )
                                    }
                                    placement={'left'}
                                  >
                                    <Field>
                                      <FormInput
                                        name={op}
                                        id={op}
                                        autoComplete="off"
                                        value={
                                          value != null
                                            ? getMultiSelectFormValue(
                                              value,
                                              sskpi.customOptions,
                                            )
                                            : ''
                                        }
                                        inputType={sskpi.unitMeasure.inputType}
                                        //style={isFromFSMIntegration == true ? { border: "2px solid #50af47" } : highlightField ? { border: "2px solid #FBBA00" } : {}}
                                        customOptions={sskpi.customOptions}
                                        className={
                                          `${findValue?.toleranceInvalid ? 'alert-input ' : ''}${shouldShowBlockedAlert
                                            ? 'alert-input-hasValue'
                                            : ''}`
                                        }
                                        blockedValueAlert={shouldShowBlockedAlert}
                                        disabled={
                                          moduleObject.isEditable
                                            ? blockedField
                                              ? true
                                              : disabledField
                                            : true
                                        }
                                        onChange={f => {
                                          setText({
                                            subSectionKPI: sskpi,
                                            ref: sskpi.refNumber,
                                            value:
                                              Array.isArray(f) && f.length > 0
                                                ? JSON.stringify(f)
                                                : '',
                                            column:
                                              numberOfColumns > 1
                                                ? indCol
                                                : null,
                                            moduleObject: moduleObject,
                                            setModuleObject: setModuleObject,
                                            subSectionKPIs: subSectionKPIs,
                                            cultureTypeID:
                                              selectedCultureTypeID ?? null,
                                            setSubsectionKPIs: setSubsectionKPIs,
                                          });
                                        }}
                                      />
                                      {sskpi.mandatory == true && (
                                        <div class="required-icon">
                                          <div class="text">*</div>
                                        </div>
                                      )}
                                    </Field>
                                  </OverlayTrigger>
                                </>
                              ) : (
                                <>
                                  {loadRefNumbersAndCalculations(sskpi)}
                                  <OverlayTrigger
                                    delay={{ hide: 0, show: 100 }}
                                    overlay={props =>
                                      value != null ||
                                        sskpi.inputMessage != null ? ( //validate overlay when field is text on Prompt Actions Modules
                                        <Tooltip {...props}>
                                          {tooltipShowsStoredValue(value)
                                            ? (typeof value === 'number' || isCalculation)
                                              ? formatValuesInTooltipNumber(
                                                value,
                                                unitMeasure.decimalSeparator,
                                                unitMeasure.decimalPrecision,
                                                unitMeasure.suffix,
                                                isCalculation,
                                              )
                                              : value
                                            : sskpi.inputMessage
                                              ? sskpi.inputMessage
                                              : ''}
                                        </Tooltip>
                                      ) : (
                                        <></>
                                      )
                                    }
                                    placement={'left'}
                                  >
                                    <Field>
                                      <FormInput
                                        name={op}
                                        id={op}
                                        autoComplete="off"
                                        value={value != null ? value : ''}
                                        inputType={sskpi.unitMeasure.inputType}
                                        style={
                                          isFromFSMIntegration == true
                                            ? { border: '2px solid #50af47' }
                                            : highlightField
                                              ? { border: '2px solid #FBBA00' }
                                              : highlightBorderColor
                                                ? {
                                                  border: `2px solid ${sskpi.borderColor}`,
                                                }
                                                : {}
                                        }
                                        customOptions={sskpi.customOptions}
                                        className={
                                          `${findValue?.toleranceInvalid ? 'alert-input ' : ''}${moduleObject.isEditable
                                            ? shouldShowBlockedAlert
                                              ? 'alert-input-hasValue'
                                              : ''
                                            : 'read-only'}`
                                        }
                                        blockedValueAlert={
                                          moduleObject.isEditable && shouldShowBlockedAlert
                                        }
                                        disabled={
                                          moduleObject.isEditable
                                            ? blockedField
                                              ? true
                                              : disabledField
                                            : true
                                        }
                                        onChange={f => {
                                          setText({
                                            subSectionKPI: sskpi,
                                            ref: sskpi.refNumber,
                                            value: f.target.value,
                                            column:
                                              numberOfColumns > 1
                                                ? indCol
                                                : null,
                                            moduleObject: moduleObject,
                                            setModuleObject: setModuleObject,
                                            subSectionKPIs: subSectionKPIs,
                                            cultureTypeID:
                                              selectedCultureTypeID ?? null,
                                            setSubsectionKPIs: setSubsectionKPIs,
                                          });
                                        }}
                                      />
                                      {sskpi.mandatory == true && (
                                        <div class="required-icon">
                                          <div class="text">*</div>
                                        </div>
                                      )}
                                    </Field>
                                  </OverlayTrigger>
                                </>
                              )
                            ) : sskpi.listTreeID && sskpi.optionsModeView > 0 ? (
                              <>
                                {loadRefNumbersAndCalculations(sskpi)}
                                <Field>
                                  <FormInput
                                    name={op}
                                    id={op}
                                    inputType="listtreeselect"
                                    listTreeID={sskpi.listTreeID}
                                    optionsModeView={sskpi.optionsModeView}
                                    allowSelectOnlyChildrenNodes={sskpi.allowSelectOnlyChildrenNodes}
                                    maxTreeDepth={sskpi.maxTreeDepth}
                                    parentItemIDsFilter={parentItemIDsFilter}
                                    value={value != null ? value : ''}
                                    disabled={true}
                                    onChange={() => {}}
                                  />
                                </Field>
                              </>
                            ) : sskpi.unitMeasure.type === 'Selection from kpi' &&
                              sskpi.selectAnswersRefNumber ? (
                              <SelectionFromKpiSelectField
                                sskpi={sskpi}
                                refSubSectionKPI={subSectionKPIs.find(
                                  x => x.refNumber === sskpi.selectAnswersRefNumber,
                                )}
                                fallbackOptions={SSKReferenceAnswersOptionsList}
                                numberOfRows={numberOfRows}
                                row={row}
                                numberOfColumns={numberOfColumns}
                                column={indCol}
                                moduleObject={moduleObject}
                                op={op}
                                value={value}
                                disabledField={disabledField}
                                loading={loading}
                                setText={setText}
                                subSectionKPIs={subSectionKPIs}
                                findValue={findValue}
                                loadRefNumbersAndCalculations={loadRefNumbersAndCalculations}
                                cultureTypeID={selectedCultureTypeID ?? null}
                                setSubsectionKPIs={setSubsectionKPIs}
                                readOnly={true}
                              />
                            ) : isNumber ? (
                              <>
                                {loadRefNumbersAndCalculations(sskpi)}
                                <OverlayTrigger
                                  delay={{ hide: 0, show: 100 }}
                                  overlay={props =>
                                    value != null ||
                                      sskpi.inputMessage != null ? ( //validate overlay when field is text on Prompt Actions Modules
                                      <Tooltip {...props}>
                                        {tooltipShowsStoredValue(value)
                                            ? formatValuesInTooltipNumber(
                                              value,
                                              unitMeasure.decimalSeparator,
                                              unitMeasure.decimalPrecision,
                                              unitMeasure.suffix,
                                              isCalculation,
                                            )
                                            : sskpi.inputMessage
                                              ? sskpi.inputMessage
                                              : ''}
                                      </Tooltip>
                                    ) : (
                                      <></>
                                    )
                                  }
                                  placement={'left'}
                                >
                                  <div className="text-center">
                                    {formatValuesInTooltip(
                                      value,
                                      unitMeasure.decimalSeparator,
                                      unitMeasure.decimalPrecision,
                                      unitMeasure.suffix,
                                      moduleObject.isEditable,
                                      isCalculation,
                                      highlightField,
                                      highlightBorderColor,
                                      sskpi.borderColor,
                                    )}
                                  </div>
                                </OverlayTrigger>
                              </>
                            ) : sskpi.unitMeasure.inputType === '' ||
                              sskpi.unitMeasure.inputType === 'text' ||
                              (sskpi.unitMeasure.inputType === 'multiselectcustom' &&
                                !moduleObject.isEditable) ? (
                              <>
                                {loadRefNumbersAndCalculations(sskpi)}
                                <OverlayTrigger
                                  delay={{ hide: 0, show: 100 }}
                                  overlay={props =>
                                    value != null ||
                                      sskpi.inputMessage != null ? ( //validate overlay when field is text on Prompt Actions Modules
                                      <Tooltip {...props}>
                                        {tooltipShowsStoredValue(value)
                                          ? sskpi.unitMeasure.inputType === 'multiselectcustom'
                                            ? formatMultiSelectValue(value)
                                            : value
                                          : sskpi.inputMessage
                                            ? sskpi.inputMessage
                                            : ''}
                                      </Tooltip>
                                    ) : (
                                      <></>
                                    )
                                  }
                                  placement={'left'}
                                >
                                  <textarea
                                    name={op}
                                    id={op}
                                    autoComplete="off"
                                    style={
                                      isFromFSMIntegration == true
                                        ? { border: '2px solid #50af47' }
                                        : highlightField
                                          ? { border: '2px solid #FBBA00' }
                                          : {}
                                    }
                                    value={
                                      value != null
                                        ? sskpi.unitMeasure.inputType == 'date'
                                          ? getFormattedDate(value)
                                          : sskpi.unitMeasure.inputType == 'multiselectcustom'
                                            ? formatMultiSelectValue(value)
                                            : value
                                        : ''
                                    }
                                    title={
                                      moduleObject.isEditable
                                        ? sskpi.inputMessage
                                        : ''
                                    }
                                    inputType={'text'}
                                    className={
                                      isNumber && isCalculation
                                        ? 'read-only-total'
                                        : 'read-only'
                                    }
                                    disabled={
                                      moduleObject.isEditable ? false : true
                                    }
                                  />
                                </OverlayTrigger>
                              </>
                            ) : (
                              <>
                                {loadRefNumbersAndCalculations(sskpi)}
                                <OverlayTrigger
                                  delay={{ hide: 0, show: 100 }}
                                  overlay={props =>
                                    value != null ||
                                      sskpi.inputMessage != null ? ( //validate overlay when field is text on Prompt Actions Modules
                                      <Tooltip {...props}>
                                        {tooltipShowsStoredValue(value)
                                            ? (typeof value === 'number' || isCalculation)
                                              ? formatValuesInTooltipNumber(
                                                value,
                                                unitMeasure.decimalSeparator,
                                                unitMeasure.decimalPrecision,
                                                unitMeasure.suffix,
                                                isCalculation,
                                              )
                                              : value
                                            : sskpi.inputMessage
                                              ? sskpi.inputMessage
                                              : ''}
                                      </Tooltip>
                                    ) : (
                                      <></>
                                    )
                                  }
                                  placement={'left'}
                                >
                                  <input
                                    name={op}
                                    id={op}
                                    autoComplete="off"
                                    style={
                                      isFromFSMIntegration == true
                                        ? { border: '2px solid #50af47' }
                                        : highlightField
                                          ? { border: '2px solid #FBBA00' }
                                          : highlightBorderColor
                                            ? {
                                              border: `2px solid ${sskpi.borderColor}`,
                                            }
                                            : {}
                                    }
                                    value={
                                      value != null
                                        ? sskpi.unitMeasure.inputType == 'date'
                                          ? getFormattedDate(value)
                                          : value
                                        : ''
                                    }
                                    title={
                                      moduleObject.isEditable
                                        ? sskpi.inputMessage
                                        : ''
                                    }
                                    inputType={'text'}
                                    className={
                                      isNumber && isCalculation
                                        ? 'read-only-total'
                                        : 'read-only'
                                    }
                                    disabled={
                                      moduleObject.isEditable ? false : true
                                    }
                                  />
                                </OverlayTrigger>
                              </>
                            )}
                          </div>
                          <div
                            className="col-1"
                            style={{ paddingTop: 0, paddingLeft: 0 }}
                          >
                            {hasDiscussion ? (
                              <a
                                href="#"
                                style={{
                                  marginLeft: '0.25rem',
                                  pointerEvents: 'none',
                                }}
                              >
                                <MdChat
                                  color={
                                    discussionCollor != ''
                                      ? discussionCollor
                                      : '#fff'
                                  }
                                ></MdChat>
                                {IconDiscussionToAnswer(hasDiscussion)}
                              </a>
                            ) : (
                              <></>
                            )}
                            <a
                              id={op + '_comment'}
                              name={op + '_comment'}
                              onClick={() => {
                                funcCollapse(
                                  sskpi.subSectionKPIID,
                                  op,
                                  null,
                                  numberOfColumns > 1 ? indCol : null,
                                );
                              }}
                            >
                              {collapse == sskpi.subSectionKPIID &&
                                (numberOfColumns > 1
                                  ? collapseCol == indCol
                                  : true) ? (
                                <FaAngleUp
                                  size={20}
                                  color={
                                    (comment != '' && comment != null) ||
                                      (file != '' && file != null)
                                      ? 'green'
                                      : (sskpi.comment == 'Mandatory' ||
                                        sskpi.evidence == 'Mandatory' ||
                                        (sskpi.mandatoryAttachment && (value == null || value === '' || Number(value) !== 0))) &&
                                        (isCalculation || !disabledField) &&
                                        !colDisabled
                                        ? 'red'
                                        : ''
                                  }
                                />
                              ) : (
                                <FaAngleDown
                                  size={20}
                                  color={
                                    (comment != '' && comment != null) ||
                                      (file != '' && file != null)
                                      ? 'green'
                                      : (sskpi.comment == 'Mandatory' ||
                                        sskpi.evidence == 'Mandatory' ||
                                        (sskpi.mandatoryAttachment && (value == null || value === '' || Number(value) !== 0))) &&
                                        (isCalculation || !disabledField) &&
                                        !colDisabled
                                        ? 'red'
                                        : ''
                                  }
                                />
                              )}
                            </a>
                          </div>
                        </div>
                      </td>
                    </>
                  );
                } else {
                  //return <></>
                  const cellMinW =
                    valueCellMinWidthByColumnRowID?.[columnRow.columnRowID] ??
                    valueCellMinWidthPx;
                  const _cellW = Math.max(
                    isColumnOverload ? 100 : 0,
                    cellMinW,
                  );
                  return (
                    <td
                      key={`subSectionKPI_td_${index}`}
                      colSpan={1}
                      style={{
                        width: `${_cellW}px`,
                        minWidth: `${_cellW}px`,
                        maxWidth: `${_cellW}px`,
                      }}
                    ></td>
                  );
                }
                });
              
            })
        }
      </tr>
      {columnRows
        .filter(x => x.isParentColumn == false)
        .map((columnRow, index) => {
          var sskpi = kpi.subSectionKPIs.find(
            x => x.columnRowID == columnRow.columnRowID,
          );
          if (sskpi) {
            var numberOfColumns = columnRow.minimumQuantity;
            return [...Array(numberOfColumns > 1 ? numberOfColumns : 1)].map(
              (x, i) => {
                var unitMeasure = GetTypeInput(
                  sskpi.unitMeasureID,
                  sskpi.unitMeasure.type,
                );
                var isNumber =
                  sskpi.unitMeasure.inputType == 'number' ||
                    sskpi.unitMeasure.inputType == 'decimal'
                    ? true
                    : false;
                var findValue = null;
                var file = undefined;
                var selectedCultureTypeID =
                  cultureTypeID == null
                    ? selectedCultureTypes[i]?.value
                    : cultureTypeID;
                var comment = '';
                var value;

                var op = `subSectionKPI_${sskpi.subSectionKPIID}_${sskpi.columnRowID}`;

                if (numberOfColumns > 1) {
                  op = `subSectionKPI_${sskpi.subSectionKPIID}_${sskpi.columnRowID}_c${i}`;
                }

                if (numberOfColumns > 1) {
                  findValue = moduleObject.answers.find(
                    x =>
                      x.subSectionKPIID == sskpi.subSectionKPIID &&
                      x.refNumber == sskpi.refNumber &&
                      x.column == i,
                  );
                } else {
                  findValue = moduleObject.answers.find(
                    x =>
                      x.subSectionKPIID == sskpi.subSectionKPIID &&
                      x.refNumber == sskpi.refNumber,
                  );
                }

                if (findValue != undefined && findValue != null) {
                  file = findValue.file;
                  comment = findValue.comment;
                  value = isNumber
                    ? findValue.numberValue
                    : findValue.textValue;
                }

                var sskEvidence = kpiEvidences.find(
                  x => x.subSectionKPIID == sskpi.subSectionKPIID,
                );
                // && (numberOfColumns > 1 ? x.column == i : true)
                // && (selectedCultureTypeID && columnRow.type == 4 ? selectedCultureTypeID == x.cultureTypeID: null))

                return (
                  <Collapse
                    in={collapse == sskpi.subSectionKPIID && collapseText == op}
                  >
                    <tr
                      colSpan={totalColumns + 3}
                      style={{
                        verticalAlign: 'top',
                        backgroundColor: 'rgb(250 250 250)',
                      }}
                    >
                      <td
                        colSpan={totalColumns + 3}
                        style={{ textAlign: 'left', padding: 25 }}
                      >
                        <div className="row">
                          <div className="col-lg-6">
                            <p>
                              Comment{' '}
                              {sskpi.comment == 'Mandatory' && (
                                <span className="required-kpi">*</span>
                              )}
                            </p>
                            <CommentTextArea
                              key={`${op}_${findValue?.thriveValueID ?? 'na'}_${findValue?.numberValue ?? ''}_${findValue?.textValue ?? ''}_${findValue?.comment ?? ''}`}
                              name={op + '_commentText'}
                              id={op + '_commentText'}
                              rows="5"
                              style={{
                                margin: 0,
                                width: '100%',
                                backgroundColor: '#fff',
                              }}
                              defaultValue={comment}
                              disabled={
                                moduleObject.isEditable &&
                                  findValue != undefined &&
                                  findValue != null
                                  ? false
                                  : true
                              }
                              className={
                                moduleObject.isEditable ? '' : 'block-comment'
                              }
                              onBlur={e =>
                                setComment({
                                  subSectionKPI: sskpi,
                                  ref: sskpi.refNumber,
                                  value: e.target.value,
                                  column: numberOfColumns > 1 ? i : null,
                                  row: null,
                                  moduleObject: moduleObject,
                                  setModuleObject: setModuleObject,
                                  selectedCultureTypes: selectedCultureTypes,
                                  subSectionKPIs: subSectionKPIs,
                                })
                              }
                            ></CommentTextArea>
                          </div>

                          <div className="col-lg-2">
                            <ChatButton
                              kpiDiscussions={kpiDiscussions}
                              setChatRequest={setChatRequest}
                              setShowChat={setShowChat}
                              request={{
                                ...defaultChatRequest,
                                subSectionKPIID: sskpi.subSectionKPIID,
                                kpiId: sskpi.kpiid,
                                cultureTypeID:
                                  selectedCultureTypeID && columnRow.type == 4
                                    ? selectedCultureTypeID
                                    : null,
                                column: numberOfColumns > 1 ? i : null,
                              }}
                            />
                            {sskpi?.evidence == 'Mandatory' && (
                              <EvidenceButton
                                kpiEvidences={kpiEvidences}
                                setEvidenceRequest={setEvidenceRequest}
                                setShowUploadEvidence={setShowUploadEvidence}
                                isMandatory={true}
                                moduleObject={moduleObject}
                                evidenceRequest={{
                                  ...defaultEvidenceRequest,
                                evidenceRefValidateValue:
                                  getLiveEvidenceRefValidateValue({
                                    moduleObject,
                                    subSectionKPIs,
                                    evidenceSubSectionKPI: sskpi,
                                    numberOfRows,
                                    columnRows,
                                    reordenateColumns,
                                    evidenceColumn:
                                      numberOfColumns > 1 ? i : undefined,
                                    evidenceCultureTypeID:
                                      selectedCultureTypeID,
                                  }),
                                  subSectionKPIID: sskpi.subSectionKPIID,
                                  cultureTypeID:
                                    selectedCultureTypeID && columnRow.type == 4
                                      ? selectedCultureTypeID
                                      : null,
                                  column: numberOfColumns > 1 ? i : null,
                                  subSectionKPIValue: value ?? 0,
                                  file: sskEvidence?.file,
                                  value: sskEvidence?.value,
                                  farmersCount: sskEvidence?.farmersCount,
                                  isValidated: sskEvidence?.isValidated,
                                }}
                              />
                            )}
                          </div>
                          <div className="col-lg-4">
                            <p>Files {(sskpi.mandatoryAttachment && (value == null || value === '' || Number(value) !== 0)) && (
                              <span className="required-kpi">*</span>
                            )} </p>
                            {moduleObject.isEditable &&
                              userRoles.includes('RoleInfoHolder') && (
                                <>
                                  <div className="upload-btn-wrapper">
                                    <button
                                      id={op + '_file'}
                                      className="btn-custom"
                                      disabled={
                                        findValue != undefined &&
                                          findValue != null
                                          ? false
                                          : true
                                      }
                                    >
                                      Upload a file (need to save the form)
                                    </button>
                                    <input
                                      type="file"
                                      disabled={
                                        findValue != undefined &&
                                          findValue != null
                                          ? false
                                          : true
                                      }
                                      onChange={files => {
                                        uploadFile({
                                          subSectionKPI: sskpi,
                                          ref: sskpi.refNumber,
                                          files: files,
                                          column:
                                            numberOfColumns > 1 ? i : null,
                                          row: null,
                                          moduleObject: moduleObject,
                                          setModuleObject: setModuleObject,
                                          selectedCultureTypes:
                                            selectedCultureTypes,
                                          subSectionKPIs: subSectionKPIs,
                                        });
                                      }}
                                    />
                                    {/* <input type="file" onChange={(files) => uploadFile(sskpi, sskpi.refNumber, files, numberOfColumns > 1 ? i : null, numberOfColumns > 1 ? cultureTypeID : null, null)} /> */}
                                  </div>
                                  <br />
                                </>
                              )}
                            {file != '' &&
                              file != null &&
                              file.length > 0 &&
                              file.filter(e => !e.isDeleted).length > 0 ? (
                              Array.isArray(file) ? (
                                file
                                  .filter(e => !e.isDeleted)
                                  .map(e => {
                                    return (
                                      <>
                                        {e.file
                                          .toLowerCase()
                                          .includes('docx') ? (
                                          <AiFillFileWord
                                            style={{ marginLeft: 20 }}
                                            title={e.file}
                                            size={25}
                                            onClick={() => getFile(e.file)}
                                          ></AiFillFileWord>
                                        ) : e.file
                                          .toLowerCase()
                                          .includes('pdf') ? (
                                          <AiFillFilePdf
                                            style={{ marginLeft: 20 }}
                                            title={e.file}
                                            size={25}
                                            onClick={() => getFile(e.file)}
                                          ></AiFillFilePdf>
                                        ) : e.file
                                          .toLowerCase()
                                          .includes('png') ||
                                          e.file
                                            .toLowerCase()
                                            .includes('jpg') ||
                                          e.file
                                            .toLowerCase()
                                            .includes('jfif') ? (
                                          <AiFillFileImage
                                            style={{ marginLeft: 20 }}
                                            title={e.file}
                                            size={25}
                                            onClick={() => getFile(e.file)}
                                          ></AiFillFileImage>
                                        ) : e.file
                                          .toLowerCase()
                                          .includes('xlsx') ? (
                                          <AiFillFileExcel
                                            style={{ marginLeft: 20 }}
                                            title={e.file}
                                            size={25}
                                            onClick={() => getFile(e.file)}
                                          ></AiFillFileExcel>
                                        ) : (
                                          <FaFileAlt
                                            style={{ marginLeft: 20 }}
                                            title={e.file}
                                            size={25}
                                            onClick={() => getFile(e.file)}
                                          ></FaFileAlt>
                                        )}
                                        {userRoles.includes('RoleInfoHolder') &&
                                          moduleObject.isEditable && (
                                            <AiFillCloseCircle
                                              className="delete-button"
                                              size={15}
                                              onClick={() => {
                                                removeFile({
                                                  subSectionKPI: sskpi,
                                                  ref: sskpi.refNumber,
                                                  value: e.file,
                                                  column:
                                                    numberOfColumns > 1
                                                      ? i
                                                      : null,
                                                  row: null,
                                                  moduleObject: moduleObject,
                                                  setModuleObject:
                                                    setModuleObject,
                                                  selectedCultureTypes:
                                                    selectedCultureTypes,
                                                  subSectionKPIs:
                                                    subSectionKPIs,
                                                  deleteFile: true,
                                                });
                                              }}
                                            ></AiFillCloseCircle>
                                          )}
                                      </>
                                    );
                                  })
                              ) : (
                                file
                              )
                            ) : (
                              <>No file attached</>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* {evidenceRequest.file != null &&
                                <tr colSpan={totalColumns + 3} style={{ verticalAlign: "top", backgroundColor: "rgb(250 250 250)" }}>

                                </tr>


                                } */}
                  </Collapse>
                );
              },
            );
          }
        })}
    </>
  );
};

export default ColumnSimpleGrouped;

